<template>
  <div>
    <div class="container" style="padding-top:20px;" v-if="!status">
      <div style="padding: 0 10px;margin-bottom:20px;display: flex;align-items:center;">

        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/images/gdteLogoNew.jpeg" alt="" style="width: 50px;height: 50px;margin-right:5px;">

        <h2>全球数字贸易博览会展商调研问题表</h2>

      </div>


      <div style="width:100%;padding: 0 20px;">
        <video src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/data/gdte.mp4" controls style="width:100%;"></video>
      </div>

      <div v-html="desc" style="text-align:left;padding:0 20px;margin-top:20px;margin-bottom:20px">

      </div>

      <van-form @submit="onSubmit" label-align='left'>
        <!-- 自定义表单 -->

        <template v-for="(item, index) in customFiledArr">
          <div v-if="item.type == 'checkBox'" :key="index" style="border-bottom:1px solid #ebedf0;text-align:left;">
            <van-field class="vanCell" :name="item.type" :left-icon='item.needIcon ? starIcon : ""' :label="item.label" :rules="[{ required: true, message: item.rulesMes }]">
              <template #input>
                <van-checkbox-group v-model="item.value" :max='item.max' direction="vertical" @change="checkBoxChange(item, index, $event)">
                  <template v-for="(sitem, sindex) in item.child">
                    <van-checkbox style="margin-bottom: 10px;" :name="sitem.key" shape="square" :key="sindex">{{sitem.label}}</van-checkbox>

                  </template>
                  <van-field style="border:1px solid #ccc" :border='true' v-if="item.showInp" :placeholder="item.otherMes" v-model="item.otherWord" :rules="[{ required: true, message: '请填写' }]" />
                </van-checkbox-group>

              </template>
            </van-field>
          </div>

          <div v-if="item.type == 'input'" :key="index" style="border-bottom:1px solid #ebedf0;text-align:left;">
            <van-field class="vanCell" v-model="item.value" :left-icon='item.needIcon ? starIcon : ""' :label="item.label" :placeholder="item.mes" :rules="[{ required: true, message: item.rulesMes }]" />
          </div>

          <div v-if="item.type == 'radio'" :key="index" style="border-bottom:1px solid #ebedf0;text-align:left;">
            <van-field class="vanCell" v-model="item.value" :left-icon='item.needIcon ? starIcon : ""' :label="item.label" :rules="[{ required: true, message: item.rulesMes }]">
              <template #input>
                <van-radio-group v-model="item.value" @change="radioBoxChange(item, index,$event)">
                  <template v-for="(sitem, sindex) in item.child">
                    <van-radio style="margin-bottom: 10px;" :name="sitem.key" :key="sindex">{{sitem.label}}</van-radio>

                    <van-field style="border:1px solid #ccc" :border='true' v-if="sitem.showInp" :placeholder="item.otherMes" v-model="sitem.otherWord" :rules="[{ required: true, message: '请填写' }]" />

                  </template>
                </van-radio-group>
              </template>
            </van-field>
          </div>

        </template>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>

    <div v-if='status' style="text-align:center;padding: 120px 30px 0 30px; ">
      <img src="../../../public/images/bigRight.png" alt="" style="width:64px;height:64px;">
      <div style="font-size: 22px;font-weight: 500;color: #2F2F2F;margin-top:15px;margin-bottom:35px;">
        问卷提交成功
      </div>

      <!-- <div style="width: 85vw;height: 50px;border-radius: 25px;border: 1px solid #03A64D;position:fixed;bottom: 100px;font-size: 16px;font-weight: 400;color: #fff;text-align:center;line-height:50px;background: #03A64D;" @click="goBackHome()">
        进入首页
      </div> -->

    </div>

  </div>

</template>


<script>
import { noTokenQuestionnaireAdd, checkSubmitNaire } from '../../api/questionApi'

import { GetQueryString } from '@/utils/utils'
import formValite from '@/utils/form'
export default {
  name: 'visitorRegister',
  data() {
    return {
      form: {
        sex: 1,
      },
      desc: `<p style=";font-family: Calibri;font-size: 14px;text-indent: 0;white-space: normal">
    <span style="font-family: 方正仿宋_GB2312;font-size: 14px">尊敬的参展商</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">：</span>
</p>
<p style=";font-family: Calibri;font-size: 14px;text-indent: 0;white-space: normal;margin-top:10px;">
    <span style="font-family: 方正仿宋_GB2312;font-size: 14px">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">首届全球数字贸易博览会将于</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">2022</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">年</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">12</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">月</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">11</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">日</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">-14</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">日举办</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">，</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">为了让您在本次博览会期间获得更好的体验</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">，</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">诚挚的邀请您完成以下需求调研</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">，</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">便于我们提供更好的服务</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">。</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">在此衷心的感谢您的支持</span><span style="font-family: 方正仿宋_GB2312;font-size: 14px">！</span>
</p>`,
      cascaderValue: '',
      show: false,
      starIcon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/needForm.png',
      options: [],
      cardType: [
        {
          name: '身份证',
          key: 'CERTIFICATES_TYPE_1',
        },
        {
          name: '港澳居民来往内地通行证',
          key: 'CERTIFICATES_TYPE_2',
        },
        {
          name: '台湾居民来往大陆通行证',
          key: 'CERTIFICATES_TYPE_3',
        },
        {
          name: '外国人永久居住证',
          key: 'CERTIFICATES_TYPE_4',
        },
        {
          name: '护照',
          key: 'CERTIFICATES_TYPE_5',
        },
        {
          name: '其他',
          key: 'CERTIFICATES_TYPE_99',
        },
      ],
      columns: ['身份证', '港澳居民来往内地通行证', '台湾居民来往大陆通行证', '外国人永久居住证', '护照', '其他'],
      customFiledArr: window['GDTE_QUESTION_NEW'],
      isRegister: false, // 是否注册
      isShow: false,
      isHaveUserInfo: false, //用户是否有实名信息
      showPicker: false,
      status: false,
      submitFlag: false,
    }
  },
  created() {
    document.title = '全球数字贸易博览会参展商调研表'
    // this.appKey = GetQueryString('appKey') || 'WX_MINI_MEHZ'
    // this.eventKey = GetQueryString('eventKey') || 'MEHZ'
    // this.token = GetQueryString('token')
    // this.checkStatus()
    console.log(window['GDTE_QUESTION_NEW'])
    let isSubFlag = localStorage.getItem('isSub')
    if (isSubFlag) {
      this.status = true
    }
  },
  methods: {
    checkStatus() {
      var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }
      checkSubmitNaire(headers, 'EBE_2022').then((res) => {
        console.log(res)
        this.status = res.data
        // this.status = false
        this.isShow = true
      })
    },
    onSubmit(e) {
      console.log(e, this.customFiledArr)
      if (this.submitFlag) {
        return false
      }

      let formContentArr = []

      formContentArr = formValite.handleFormAttendKeyByQuestion(formContentArr, this.customFiledArr)

      const data = {
        feedbackCode: 'GDTE_2022_NEW',
        feedbackContent: JSON.stringify(formContentArr),
        feedbackName: '全球数字贸易博览会展商调研问题表',
      }

      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }

      noTokenQuestionnaireAdd(headers, data).then((res) => {
        console.log(res)
        // this.checkStatus()
        if (res.code == 200) {
          this.submitFlag = false
          this.status = true
          localStorage.setItem('isSub', true)
        } else {
          this.submitFlag = false
          this.$toast.fail(res.msg)
        }
      })
    },
    // 返回首页
    goBackHome() {
      wx.miniProgram.navigateBack({
        delta: 1,
      })
    },
    // 监听多选框事件
    checkBoxChange(nowCheck, nowIndex, e) {
      const nowChild = nowCheck.child
      let hasCheckOther = false
      let valueName = []
      for (let i in e) {
        let checkItem = nowChild.filter((v) => v.key == e[i])
        checkItem[0].type == 'other' ? (hasCheckOther = true) : ''
        valueName.push(checkItem[0].label)
      }
      this.customFiledArr[nowIndex].showInp = hasCheckOther
      this.customFiledArr[nowIndex].valueName = valueName
    },

    radioBoxChange(nowCheck, nowIndex, e) {
      console.log(nowCheck, nowIndex, e)
      // 判断是否含有子集child，如果有加入表单
      let hasChild = nowCheck.child.filter((v) => v.key == e)[0].child
      console.log(hasChild && hasChild.length > 0)
      if (hasChild && hasChild.length > 0) {
        this.customFiledArr = this.customFiledArr.filter((v) => !v.isChildShow)
        hasChild.forEach((v) => {
          v.isChildShow = true
        })
        this.customFiledArr.push(...hasChild)
      }

      // 判断是否为可输入
      let isOtherItem = nowCheck.child.findIndex((v) => v.key == nowCheck.value && v.type == 'other')
      console.log(isOtherItem)
      // >0 则 选择了其他，点击显示输入框
      if (isOtherItem >= 0) {
        this.customFiledArr[nowIndex].child = formValite.resetOtherStatus(this.customFiledArr[nowIndex].child, true)
      } else {
        this.customFiledArr[nowIndex].child = formValite.resetOtherStatus(this.customFiledArr[nowIndex].child, false)
      }
    },
  },
}
</script>


<style lang="less" scoped>
.container {
  background: #fafafa;
  min-height: 100vh;
  .title {
    font-size: 14px;
    line-height: 16px;
    padding: 32px 16px 16px;
    color: rgba(69, 90, 100, 0.6);
    text-align: left;
  }
}
</style>


<style lang='less'>
.van-checkbox__label {
  width: 80vw;
}
.van-radio__label {
  width: 80vw;
}
.vantAreaCell {
  padding: 0 16px 10px 16px;
  &.van-cell::after {
    display: none;
  }
}

.vanCell {
  display: block;
  text-align: left;
  .van-field__left-icon {
    display: inline-block;
    line-height: 1;
    position: relative;
    left: -10px;
  }
  .van-field__label {
    display: inline-block;
    width: 80vw;
    position: relative;
    left: -10px;
    margin-bottom: 20px;
  }
}
</style>